import Spinner from "tds/spinner";

export { Spinner };

customElements.define("tds-spinner", Spinner.CustomElementConstructor);
